const x = true
const defaultSurveyJSON = {
  logoPosition: "right",
  pages: [
    {
      name: "page3",
      elements: [
        {
          type: "paneldynamic",

          name: "investigation",

          title: "Investigation",

          hideNumber: true,

          templateElements: [
            {
              type: "dropdown",

              name: "Test",

              title: "Test",

              choices: [
                {
                  value: "item1",

                  text: "CT",
                },

                {
                  value: "item2",

                  text: "PET CT",
                },

                {
                  value: "item3",

                  text: "MRI",
                },

                {
                  value: "item4",

                  text: "USG",
                },

                {
                  value: "item5",

                  text: "Doppler",
                },

                {
                  value: "item6",

                  text: "MRCP",
                },

                {
                  value: "item7",

                  text: "Endoscopy",
                },
              ],
            },

            {
              type: "dropdown",

              name: "dopplerOptions",

              visibleIf: "{panel.Test} = 'item5'",

              startWithNewLine: false,

              title: "Doppler Options",

              choices: [
                {
                  value: "item1",

                  text: "Arterial",
                },

                {
                  value: "item2",

                  text: "Venous",
                },
              ],
            },

            {
              type: "text",

              name: "MRIOptions",

              visibleIf:
                "{panel.Test} = 'item3' and {panel.MRIOptions} anyof ['item5']",

              startWithNewLine: false,

              title: "MRI Options - Others",

              hideNumber: true,
            },

            {
              type: "dropdown",

              name: "USGOptions",

              visibleIf: "{panel.Test} = 'item4'",

              startWithNewLine: false,

              title: "USG Options",

              choices: [
                {
                  value: "item1",

                  text: "(A+P)",
                },

                {
                  value: "item2",

                  text: "Thorax",
                },

                {
                  value: "item3",

                  text: "Neck",
                },

                {
                  value: "item4",

                  text: "BL axillary",
                },

                {
                  value: "item5",

                  text: "BL Inguinal",
                },
              ],
            },

            {
              type: "dropdown",

              name: "CTOptions",

              visibleIf: "{panel.Test} = 'item1'",

              startWithNewLine: false,

              title: "CT Options",

              choices: [
                {
                  value: "item1",

                  text: "(A+P)",
                },

                {
                  value: "item2",

                  text: "Thorax",
                },

                {
                  value: "item3",

                  text: "Neck",
                },

                {
                  value: "item4",

                  text: "Oral cavity",
                },

                {
                  value: "item5",

                  text: "Brain ",
                },
              ],
            },

            {
              type: "dropdown",

              name: "PetCTOptions",

              visibleIf: "{panel.Test} = 'item2'",

              startWithNewLine: false,

              title: "PET CT Options",

              choices: [
                {
                  value: "item1",

                  text: "FDG",
                },

                {
                  value: "item2",

                  text: "DOTA",
                },

                {
                  value: "item3",

                  text: "PSMA",
                },
              ],
            },

            {
              type: "dropdown",

              name: "MRIOptions",

              visibleIf: "{panel.Test} = 'item3'",

              startWithNewLine: false,

              title: "MRI Options",

              choices: [
                {
                  value: "item1",

                  text: "Brain",
                },

                {
                  value: "item2",

                  text: "Liver",
                },

                {
                  value: "item3",

                  text: "Spine",
                },

                {
                  value: "item4",

                  text: "Pelvis",
                },

                {
                  value: "item5",

                  text: "Others",
                },
              ],
            },

            {
              type: "dropdown",

              name: "MrcpIhbrDilated",

              visibleIf: "{panel.Test} = 'item6'",

              startWithNewLine: false,

              title: "MRCP (IHBR Dilated)",

              choices: [
                {
                  value: "item1",

                  text: "Yes",
                },

                {
                  value: "item2",

                  text: "No",
                },
              ],
            },

            {
              type: "dropdown",

              name: "endoscopy",

              visibleIf: "{panel.Test} = 'item7'",

              startWithNewLine: false,

              title: "Endoscopy",

              hideNumber: true,

              choices: [
                {
                  value: "item1",

                  text: "Bronchoscopy",
                },

                {
                  value: "item2",

                  text: "Cystoscopy",
                },

                {
                  value: "item3",

                  text: "Laparoscopy",
                },

                {
                  value: "item4",

                  text: "Laryngoscopy",
                },

                {
                  value: "item5",

                  text: "Mediastinoscopy",
                },

                {
                  value: "item6",

                  text: "Thoracoscopy",
                },

                {
                  value: "item7",

                  text: "Upper GI endoscopy",
                },

                {
                  value: "item8",

                  text: "Arthroscopy",
                },

                {
                  value: "item9",

                  text: "Enteroscopy",
                },

                {
                  value: "item10",

                  text: "Hysteroscopy",
                },

                {
                  value: "item11",

                  text: "Sigmoidoscopy",
                },

                {
                  value: "item12",

                  text: "Ureteroscopy",
                },
              ],
            },

            {
              type: "text",

              name: "dateOfTest",

              startWithNewLine: false,

              title: "Date of Test",

              inputType: "date",
            },

            {
              type: "text",

              name: "testFindings",

              startWithNewLine: false,

              title: "Test Findings",

              hideNumber: true,
            },

            {
              type: "file",

              name: "uploadFile",

              startWithNewLine: false,

              title: "Upload File",
            },
          ],

          showRangeInProgress: false,
        },

        {
          type: "expression",

          name: "colonoscopy",

          title: "Colonoscopy *",

          hideNumber: true,
        },

        {
          type: "text",

          name: "DateOfTest",

          startWithNewLine: false,

          title: "Date of Test",

          hideNumber: true,

          inputType: "date",
        },

        {
          type: "text",

          name: "TestFindings",

          startWithNewLine: false,

          title: "Test Findings",

          hideNumber: true,
        },

        {
          type: "file",

          name: "UploadFile",

          startWithNewLine: false,

          title: "Upload File",

          hideNumber: true,
        },

        {
          type: "paneldynamic",

          name: "primarySite",

          title: "Primary Site",

          hideNumber: true,

          templateElements: [
            {
              type: "text",

              name: "site",

              width: "225px",

              minWidth: "225px",

              maxWidth: "225px",

              startWithNewLine: false,

              title: "Site",
            },

            {
              type: "text",

              name: "extend",

              width: "225px",

              minWidth: "225px",

              maxWidth: "225px",

              startWithNewLine: false,

              title: "Extend",
            },

            {
              type: "text",

              name: "size",

              width: "100px",

              minWidth: "100px",

              maxWidth: "100px",

              startWithNewLine: false,

              title: "Size ",
            },

            {
              type: "text",

              name: "dateOfTest",

              width: "100px",

              minWidth: "100px",

              maxWidth: "100px",

              startWithNewLine: false,

              title: "(in cm)",
            },

            {
              type: "text",

              name: "testFindings",

              width: "100px",

              minWidth: "100px",

              maxWidth: "100px",

              startWithNewLine: false,

              title: " ",
            },

            {
              type: "text",

              name: "suv",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "SUV",
            },
          ],

          allowAddPanel: false,

          allowRemovePanel: false,

          panelCount: 1,

          minPanelCount: 1,

          maxPanelCount: 1,

          showRangeInProgress: false,
        },

        {
          type: "paneldynamic",

          name: "metastasisSite",

          state: "expanded",

          title: "Metastasis Site",

          hideNumber: true,

          templateElements: [
            {
              type: "dropdown",

              name: "Site",

              width: "225px",

              minWidth: "225px",

              maxWidth: "225px",

              startWithNewLine: false,

              title: "Site",

              choices: [
                {
                  value: "item1",

                  text: "Lung",
                },

                {
                  value: "item2",

                  text: "Liver",
                },

                {
                  value: "item3",

                  text: "Brain",
                },

                {
                  value: "item4",

                  text: "Adrenal",
                },

                {
                  value: "item5",

                  text: "Bone",
                },

                {
                  value: "item6",

                  text: "Breast",
                },
              ],

              hasOther: true,
            },

            {
              type: "text",

              name: "Extend",

              width: "225px",

              minWidth: "225px",

              maxWidth: "225px",

              startWithNewLine: false,

              title: "Extend",
            },

            {
              type: "text",

              name: "Size",

              width: "100px",

              minWidth: "100px",

              maxWidth: "100px",

              startWithNewLine: false,

              title: "Size",
            },

            {
              type: "text",

              name: "sizeInCm",

              width: "100px",

              minWidth: "100px",

              maxWidth: "100px",

              startWithNewLine: false,

              title: "(in cms)",
            },

            {
              type: "text",

              name: ".",

              width: "100px",

              minWidth: "100px",

              maxWidth: "100px",

              startWithNewLine: false,

              title: " ",
            },

            {
              type: "text",

              name: "SUV",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "SUV",
            },
          ],

          panelCount: 1,

          minPanelCount: 1,
        },

        {
          type: "dropdown",

          name: "histopathology",

          title: "Histopathology",

          hideNumber: true,

          defaultValue: "item7",

          isRequired: true,

          choices: [
            {
              value: "item1",

              text: "Adenocarcinoma",
            },

            {
              value: "item3",

              text: "Signet ring cell adenocarcinoma",
            },

            {
              value: "item4",

              text: "Mucinous adenocarcinoma",
            },

            {
              value: "item5",

              text: "Neuroendocrine carcinoma",
            },

            {
              value: "item6",

              text: "Lymphoma",
            },

            {
              value: "item7",

              text: "NA",
            },
          ],

          choicesOrder: "asc",

          hasOther: true,
        },

        {
          type: "checkbox",

          name: "immunohistochemical Profile",

          title: "Immunohistochemical Profile",

          hideNumber: true,

          defaultValue: ["item9"],

          choices: [
            {
              value: "item1",

              text: "CK7",
            },

            {
              value: "item4",

              text: "CK20",
            },

            {
              value: "item5",

              text: "CDX2",
            },

            {
              value: "item6",

              text: "CEA",
            },

            {
              value: "item7",

              text: "MLH1",
            },

            {
              value: "item8",

              text: "MLH2",
            },

            {
              value: "item9",

              text: "NA",
            },

            {
              value: "item10",

              text: "MSH6",
            },

            {
              value: "item11",

              text: "PMS2",
            },
          ],

          colCount: 3,
        },

        {
          type: "paneldynamic",

          name: "tumorMarkers",

          title: "Tumor Markers",

          hideNumber: true,

          defaultValue: ["item1"],

          templateElements: [
            {
              type: "dropdown",

              name: "TumorMarkerDesc",

              title: " ",

              hideNumber: true,

              defaultValue: "item3",

              choices: [
                {
                  value: "item2",

                  text: "S.CEA",
                },

                {
                  value: "item3",

                  text: "NA",
                },
              ],

              hasOther: true,
            },

            {
              type: "text",

              name: "Date",

              visibleIf: "{panel.TumorMarkerDesc} <> 'item3'",

              startWithNewLine: false,

              title: "Date",

              hideNumber: true,

              inputType: "date",
            },

            {
              type: "text",

              name: "result",

              visibleIf: "{panel.TumorMarkerDesc} <> 'item3'",

              startWithNewLine: false,

              title: "Result",

              hideNumber: true,
            },
          ],

          panelCount: 1,

          minPanelCount: 1,
        },

        {
          type: "paneldynamic",

          name: "molecularMarkers",

          title: "Molecular Markers",

          hideNumber: true,

          defaultValue: ["item1"],

          templateElements: [
            {
              type: "dropdown",

              name: "MolecularMarkerDesc",

              title: " ",

              hideNumber: true,

              defaultValue: "item5",

              choices: [
                {
                  value: "item2",

                  text: "NRAS",
                },

                {
                  value: "item3",

                  text: "KRAS",
                },

                {
                  value: "item4",

                  text: "BRAF",
                },

                {
                  value: "item5",

                  text: "NA",
                },

                {
                  value: "item6",

                  text: "MSI",
                },

                {
                  value: "item7",

                  text: "HER2",
                },

                {
                  value: "item8",

                  text: "PDL1",
                },
              ],

              hasOther: true,
            },

            {
              type: "dropdown",

              name: "KRAS",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item3'",

              startWithNewLine: false,

              title: "KRAS",

              hideNumber: true,

              defaultValue: "item1",

              choices: [
                {
                  value: "item1",

                  text: "Not Done",
                },

                {
                  value: "item2",

                  text: "Mutant",
                },

                {
                  value: "item3",

                  text: "Wild Type",
                },

                {
                  value: "item4",

                  text: "Not Amplified",
                },
              ],
            },

            {
              type: "dropdown",

              name: "BRAF",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item4'",

              startWithNewLine: false,

              title: "BRAF",

              hideNumber: true,

              defaultValue: "item1",

              choices: [
                {
                  value: "item1",

                  text: "Not Done",
                },

                {
                  value: "item2",

                  text: "Mutant",
                },

                {
                  value: "item3",

                  text: "Wild Type",
                },

                {
                  value: "item4",

                  text: "Not Amplified",
                },
              ],
            },

            {
              type: "dropdown",

              name: "MSI",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item6'",

              startWithNewLine: false,

              title: "MSI",

              hideNumber: true,

              defaultValue: "item1",

              choices: [
                {
                  value: "item1",

                  text: "Not Done",
                },

                {
                  value: "item2",

                  text: "High",
                },

                {
                  value: "item3",

                  text: "Stable (Intact Nuclear Expression)",
                },
              ],
            },

            {
              type: "dropdown",

              name: "HER2",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item7'",

              startWithNewLine: false,

              title: "HER2",

              hideNumber: true,

              defaultValue: "item1",

              choices: [
                {
                  value: "item1",

                  text: "Not Done",
                },

                {
                  value: "item2",

                  text: "Negative",
                },

                {
                  value: "item3",

                  text: "Positive +1",
                },

                {
                  value: "item4",

                  text: "Positive +2",
                },

                {
                  value: "item5",

                  text: "Positive +3",
                },
              ],
            },

            {
              type: "text",

              name: "percentage",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item8'",

              startWithNewLine: false,

              title: "Percentage",

              hideNumber: true,
            },

            {
              type: "text",

              name: "platform",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item8'",

              startWithNewLine: false,

              title: "Platform",

              hideNumber: true,
            },

            {
              type: "dropdown",

              name: "NRAS",

              visibleIf: "{panel.MolecularMarkerDesc} = 'item2'",

              startWithNewLine: false,

              title: "NRAS",

              hideNumber: true,

              defaultValue: "item1",

              choices: [
                {
                  value: "item1",

                  text: "Not Done",
                },

                {
                  value: "item2",

                  text: "Mutant",
                },

                {
                  value: "item3",

                  text: "Wild Type",
                },

                {
                  value: "item4",

                  text: "Not Amplified",
                },
              ],
            },
          ],

          panelCount: 1,

          minPanelCount: 1,
        },

        {
          type: "dropdown",

          name: "NGSTestingYes",

          width: "284px",

          minWidth: "284px",

          maxWidth: "284px",

          title: "NGS Testing",

          hideNumber: true,

          choices: [
            {
              value: "item1",

              text: "Yes",
            },

            {
              value: "item2",

              text: "No",
            },
          ],
        },

        {
          type: "paneldynamic",

          name: "NGSTesting",

          visibleIf: "{NGSTestingYes} = 'item1'",

          title: " ",

          hideNumber: true,

          templateElements: [
            {
              type: "text",

              name: "mutation",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              title: "Mutation",

              enableIf: "{NGSTesting[0].NGSTestingYes} = 'item1'",
            },

            {
              type: "text",

              name: "therapiesPatientsTumorType",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "Therapies in patients tumor type",

              hideNumber: true,

              enableIf: "{NGSTesting[0].NGSTestingYes} = 'item1'",
            },

            {
              type: "text",

              name: "therapiesOtherTumorType",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "Therapies in Other tumor type",

              hideNumber: true,

              enableIf: "{NGSTesting[0].NGSTestingYes} = 'item1'",
            },
          ],

          panelCount: 1,

          minPanelCount: 1,

          maxPanelCount: 10,

          showRangeInProgress: false,
        },

        {
          type: "paneldynamic",

          name: "ClinicalStaging",

          title: "Clinical Staging",

          hideNumber: true,

          templateElements: [
            {
              type: "dropdown",

              name: "PrimaryTumor",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "T - Primary Tumor",

              choices: [
                {
                  value: "item1",

                  text: "TX - Primary tumor cannot be assessed",
                },

                {
                  value: "item2",

                  text: "T0 - No evidence of primary tumor",
                },

                {
                  value: "item3",

                  text:
                    "Tis - Carcinoma in situ: intramucosal carcinoma (involvement of lamina propria with no extension through muscularis mucosae)",
                },

                {
                  value: "item4",

                  text:
                    "T1 - Tumor invades the submucosa (through the muscularis mucosa but not into the muscularis propria)",
                },

                {
                  value: "item5",

                  text: "T2 - Tumor invades the muscularis propria",
                },

                {
                  value: "item6",

                  text:
                    "T3 - Tumor invades through the muscularis propria into pericolorectal tissues",
                },

                {
                  value: "item7",

                  text:
                    "T4 - Tumor invades* the visceral peritoneum or invades or adheres** to adjacent organ or structure",
                },

                {
                  value: "item8",

                  text:
                    "T4a - Tumor invades* through the visceral peritoneum (including gross perforation of the bowel through tumor and continuous invasion of tumor through areas of inflammation to the surface of the visceral peritoneum)",
                },

                {
                  value: "item9",

                  text:
                    "T4b - Tumor directly invades* or adheres** to adjacent organs or structures",
                },
              ],
            },

            {
              type: "dropdown",

              name: "RegionalLymphNodes",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "N - Regional Lymph Nodes",

              choices: [
                {
                  value: 1,

                  text: "NX - Regional lymph nodes cannot be assessed",
                },

                {
                  value: 2,

                  text: "N0 - No regional lymph node metastasis",
                },

                {
                  value: 3,

                  text:
                    "N1 - One to three regional lymph nodes are positive (tumor in lymph nodes measuring ≥0.2 mm), or any number of tumor deposits are present and all identifiable lymph nodes are negative",
                },

                {
                  value: 4,

                  text: "N1a - One regional lymph node is positive",
                },

                {
                  value: 5,

                  text: "N1b - Two or three regional lymph nodes are positive",
                },

                {
                  value: 6,

                  text:
                    "N1c - No regional lymph nodes are positive, but there are tumor deposits in the subserosa, mesentery, or nonperitonealized pericolic, or perirectal/mesorectal tissues",
                },

                {
                  value: 7,

                  text: "N2 - Four or more regional lymph nodes are positive",
                },

                {
                  value: 8,

                  text: "N2a - Four to six regional lymph nodes are positive",
                },

                {
                  value: 9,

                  text: "N2b - Seven or more regional lymph nodes are positive",
                },
              ],
            },

            {
              type: "dropdown",

              name: "DistantMetastasis",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "M - Distant Metastasis",

              hideNumber: true,

              choices: [
                {
                  value: "item1",

                  text:
                    "M0 - No distant metastasis by imaging, etc.; no evidence of tumor in distant sites or organs. (This category is not assigned by pathologists)",
                },

                {
                  value: "item2",

                  text:
                    "M1 - Metastasis to one or more distant sites or organs or peritoneal metastasis is identified",
                },

                {
                  value: "item3",

                  text:
                    "M1a - Metastasis to one site or organ is identified without peritoneal metastasis",
                },

                {
                  value: "item4",

                  text:
                    "M1b - Metastasis to two or more sites or organs is identified without peritoneal metastasis",
                },

                {
                  value: "item5",

                  text:
                    "M1c - Metastasis to the peritoneal surface is identified alone or with other site or organ metastases",
                },
              ],
            },

            {
              type: "expression",

              name: "Stage",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "Please select T, N and M values to identify the stage",

              readOnly: true,

              validators: [
                {
                  type: "expression",
                },
              ],
            },

            {
              type: "text",

              name: "Remarks",

              title: "Remarks",
            },
          ],

          allowAddPanel: false,

          allowRemovePanel: false,

          panelCount: 1,

          minPanelCount: 1,

          maxPanelCount: 1,

          showRangeInProgress: false,
        },

        {
          type: "paneldynamic",

          name: "PathologicalStaging",

          title: "Pathological Staging",

          hideNumber: true,

          templateElements: [
            {
              type: "dropdown",

              name: "PrimaryTumor",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "T - Primary Tumor",

              choices: [
                {
                  value: "item1",

                  text: "TX - Primary tumor cannot be assessed",
                },

                {
                  value: "item2",

                  text: "T0 - No evidence of primary tumor",
                },

                {
                  value: "item3",

                  text:
                    "Tis - Carcinoma in situ: intramucosal carcinoma (involvement of lamina propria with no extension through muscularis mucosae)",
                },

                {
                  value: "item4",

                  text:
                    "T1 - Tumor invades the submucosa (through the muscularis mucosa but not into the muscularis propria)",
                },

                {
                  value: "item5",

                  text: "T2 - Tumor invades the muscularis propria",
                },

                {
                  value: "item6",

                  text:
                    "T3 - Tumor invades through the muscularis propria into pericolorectal tissues",
                },

                {
                  value: "item7",

                  text:
                    "T4 - Tumor invades* the visceral peritoneum or invades or adheres** to adjacent organ or structure",
                },

                {
                  value: "item8",

                  text:
                    "T4a - Tumor invades* through the visceral peritoneum (including gross perforation of the bowel through tumor and continuous invasion of tumor through areas of inflammation to the surface of the visceral peritoneum)",
                },

                {
                  value: "item9",

                  text:
                    "T4b - Tumor directly invades* or adheres** to adjacent organs or structures",
                },
              ],
            },

            {
              type: "dropdown",

              name: "RegionalLymphNodes",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "N - Regional Lymph Nodes",

              hideNumber: true,

              choices: [
                {
                  value: 1,

                  text: "NX - Regional lymph nodes cannot be assessed",
                },

                {
                  value: 2,

                  text: "N0 - No regional lymph node metastasis",
                },

                {
                  value: 3,

                  text:
                    "N1 - One to three regional lymph nodes are positive (tumor in lymph nodes measuring ≥0.2 mm), or any number of tumor deposits are present and all identifiable lymph nodes are negative",
                },

                {
                  value: 4,

                  text: "N1a - One regional lymph node is positive",
                },

                {
                  value: 5,

                  text: "N1b - Two or three regional lymph nodes are positive",
                },

                {
                  value: 6,

                  text:
                    "N1c - No regional lymph nodes are positive, but there are tumor deposits in the subserosa, mesentery, or nonperitonealized pericolic, or perirectal/mesorectal tissues",
                },

                {
                  value: 7,

                  text: "N2 - Four or more regional lymph nodes are positive",
                },

                {
                  value: 8,

                  text: "N2a - Four to six regional lymph nodes are positive",
                },

                {
                  value: 9,

                  text: "N2b - Seven or more regional lymph nodes are positive",
                },
              ],
            },

            {
              type: "dropdown",

              name: "DistantMetastasis",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "M - Distant Metastasis",

              hideNumber: true,

              choices: [
                {
                  value: "item1",

                  text:
                    "M0 - No distant metastasis by imaging, etc.; no evidence of tumor in distant sites or organs. (This category is not assigned by pathologists)",
                },

                {
                  value: "item2",

                  text:
                    "M1 - Metastasis to one or more distant sites or organs or peritoneal metastasis is identified",
                },

                {
                  value: "item3",

                  text:
                    "M1a - Metastasis to one site or organ is identified without peritoneal metastasis",
                },

                {
                  value: "item4",

                  text:
                    "M1b - Metastasis to two or more sites or organs is identified without peritoneal metastasis",
                },

                {
                  value: "item5",

                  text:
                    "M1c - Metastasis to the peritoneal surface is identified alone or with other site or organ metastases",
                },
              ],
            },

            {
              type: "text",

              name: "Stage",

              width: "284px",

              minWidth: "284px",

              maxWidth: "284px",

              startWithNewLine: false,

              title: "Stage",

              hideNumber: true,

              defaultValue: "1111",

              validators: [
                {
                  type: "expression",
                },
              ],
            },

            {
              type: "text",

              name: "Remarks",

              title: "Remarks",
            },
          ],

          allowAddPanel: false,

          allowRemovePanel: false,

          panelCount: 1,

          minPanelCount: 1,

          maxPanelCount: 1,

          showRangeInProgress: false,
        },

        {
          type: "dropdown",

          name: "HIVTest",

          title: "HIV Test*",

          hideNumber: true,

          defaultValue: "item2",

          choices: [
            {
              value: "item2",

              text: "Not Done",
            },

            {
              value: "item3",

              text: "Positive",
            },

            {
              value: "item4",

              text: "Negative",
            },
          ],
        },

        {
          type: "dropdown",

          name: "HbsAgTest",

          startWithNewLine: false,

          title: "HBS/AG Test*",

          hideNumber: true,

          defaultValue: "item2",

          choices: [
            {
              value: "item2",

              text: "Not Done",
            },

            {
              value: "item3",

              text: "Positive",
            },

            {
              value: "item4",

              text: "Negative",
            },
          ],
        },

        {
          type: "dropdown",

          name: "HcvTest",

          startWithNewLine: false,

          title: "HCV Test*",

          hideNumber: true,

          defaultValue: "item2",

          choices: [
            {
              value: "item2",

              text: "Not Done",
            },

            {
              value: "item3",

              text: "Positive",
            },

            {
              value: "item4",

              text: "Negative",
            },
          ],
        },

        {
          type: "dropdown",

          name: "PastTreatment",

          title: "Past Treatment",

          hideNumber: true,

          defaultValue: "item2",

          choices: [
            {
              value: "item1",

              text: "Yes",
            },

            {
              value: "item2",

              text: "No",
            },
          ],
        },

        {
          type: "paneldynamic",

          name: "PastTreatmentDetails",

          visibleIf: "{PastTreatment} = 'item1'",

          title: "Past Treatment Details",

          hideNumber: true,

          templateElements: [
            {
              type: "dropdown",

              name: "TreatmentIntent",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "Treatment Intent",

              choices: [
                {
                  value: "item1",

                  text: "Curative",
                },

                {
                  value: "item2",

                  text: "Palliative",
                },
              ],
            },

            {
              type: "dropdown",

              name: "Type",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "Type",

              choices: [
                {
                  value: "item1",

                  text: "Chemotherapy",
                },

                {
                  value: "item2",

                  text: "Radiation",
                },

                {
                  value: "item3",

                  text: "Surgery",
                },

                {
                  value: "item4",

                  text: "Targeted Therapy",
                },

                {
                  value: "item5",

                  text: "Immunotherapy",
                },

                {
                  value: "item6",

                  text: "Hormone Therapy",
                },

                {
                  value: "item7",

                  text: "Nuclear Medicine",
                },
              ],

              hasOther: true,
            },

            {
              type: "dropdown",

              name: "LineOfTreatment",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "Line of Treatment",

              choices: [
                {
                  value: "item1",

                  text: "1st",
                },

                {
                  value: "item2",

                  text: "2nd",
                },

                {
                  value: "item3",

                  text: "3rd+",
                },
              ],
            },

            {
              type: "dropdown",

              name: "Radiation",

              visibleIf: "{panel.Type} = 'item2'",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "Radiation:",

              choices: [
                {
                  value: "item1",

                  text: "EBRT",
                },

                {
                  value: "item2",

                  text: "3DRT",
                },

                {
                  value: "item3",

                  text: "IMRT",
                },

                {
                  value: "item4",

                  text: "IGRT",
                },

                {
                  value: "item5",

                  text: "SBRT",
                },

                {
                  value: "item6",

                  text: "Palliative RT",
                },

                {
                  value: "item7",

                  text: "Brachytherapy",
                },
              ],
            },

            {
              type: "text",

              name: "From",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "From",

              hideNumber: true,

              inputType: "date",
            },

            {
              type: "text",

              name: "To",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "To",

              hideNumber: true,

              inputType: "date",
            },

            {
              type: "text",

              name: "Details",

              width: "189px",

              minWidth: "189px",

              maxWidth: "189px",

              startWithNewLine: false,

              title: "Details",

              hideNumber: true,
            },

            {
              type: "dropdown",

              name: "ResponseCriteria",

              title: "Response Criteria",

              hideNumber: true,

              choices: [
                {
                  value: "item1",

                  text: "With Target Lesions",
                },

                {
                  value: "item2",

                  text: "Without Target Lesions",
                },
              ],
            },

            {
              type: "text",

              name: "ResponseEvaluationCycle",

              startWithNewLine: false,

              title: "Response Evaluation Cycle",

              hideNumber: true,
            },

            {
              type: "paneldynamic",

              name: "withTargetLesions",

              visibleIf: "{Panel.ResponseCriteria} = 'item1'",

              title: "With Target Lesions",

              hideNumber: true,

              templateElements: [
                {
                  type: "dropdown",

                  name: "TargetLesionsResponse",

                  width: "250px",

                  minWidth: "250px",

                  maxWidth: "250px",

                  startWithNewLine: false,

                  title: "Target Lesions Response",

                  choices: [
                    {
                      value: "item1",

                      text: "Complete Response (CR)",
                    },

                    {
                      value: "item2",

                      text: "Partial Response (PR)",
                    },

                    {
                      value: "item3",

                      text: "Progressive Disease (PD)",
                    },

                    {
                      value: "item4",

                      text: "Stable Disease (SD)",
                    },

                    {
                      value: "item5",

                      text: "Inevaluable (NE)",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "NonTargetLesionsResponse",

                  width: "250px",

                  minWidth: "250px",

                  maxWidth: "250px",

                  startWithNewLine: false,

                  title: "Non Target Lesions Response",

                  choices: [
                    {
                      value: 1,

                      text: "Complete Response (CR)",
                    },

                    {
                      value: 2,

                      text: "Non-CR / Non-PD",
                    },

                    {
                      value: 3,

                      text: "Progressive Disease (PD)",
                    },

                    {
                      value: 4,

                      text: "Inevaluable (NE)",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "NewLesions",

                  width: "250px",

                  minWidth: "250px",

                  maxWidth: "250px",

                  startWithNewLine: false,

                  title: "New Lesions",

                  hideNumber: true,

                  choices: [
                    {
                      value: "item1",

                      text: "Yes",
                    },

                    {
                      value: "item2",

                      text: "No",
                    },
                  ],
                },

                {
                  type: "expression",

                  name: "OverallResponse",

                  width: "250px",

                  minWidth: "250px",

                  maxWidth: "250px",

                  startWithNewLine: false,

                  title: "Overall Response",

                  readOnly: true,

                  validators: [
                    {
                      type: "expression",
                    },
                  ],
                },
              ],

              allowAddPanel: false,

              allowRemovePanel: false,

              panelCount: 1,

              minPanelCount: 1,

              maxPanelCount: 1,

              showRangeInProgress: false,
            },

            {
              type: "paneldynamic",

              name: "withoutTargetLesions",

              visibleIf: "{Panel.ResponseCriteria} = 'item2'",

              title: "Without Target Lesions",

              hideNumber: true,

              templateElements: [
                {
                  type: "dropdown",

                  name: "NonTargetLesionsResponse",

                  width: "350px",

                  minWidth: "350px",

                  maxWidth: "350px",

                  startWithNewLine: false,

                  title: "Non Target Lesions Response",

                  choices: [
                    {
                      value: 1,

                      text: "Complete Response (CR)",
                    },

                    {
                      value: 2,

                      text: "Non-CR / Non-PD",
                    },

                    {
                      value: 3,

                      text: "Progressive Disease (PD)",
                    },

                    {
                      value: 4,

                      text: "Inevaluable (NE)",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "NewLesions",

                  width: "350px",

                  minWidth: "350px",

                  maxWidth: "350px",

                  startWithNewLine: false,

                  title: "New Lesions",

                  hideNumber: true,

                  choices: [
                    {
                      value: "item1",

                      text: "Yes",
                    },

                    {
                      value: "item2",

                      text: "No",
                    },
                  ],
                },

                {
                  type: "expression",

                  name: "OverallResponse",

                  width: "350px",

                  minWidth: "350px",

                  maxWidth: "350px",

                  startWithNewLine: false,

                  title: "Overall Response",

                  readOnly: true,

                  validators: [
                    {
                      type: "expression",
                    },
                  ],
                },
              ],

              allowAddPanel: false,

              allowRemovePanel: false,

              panelCount: 1,

              minPanelCount: 1,

              maxPanelCount: 1,

              showRangeInProgress: false,
            },

            {
              type: "paneldynamic",

              name: "ResponseEvaluationMethod",

              title: "Response Evaluation Method",

              hideNumber: true,

              templateElements: [
                {
                  type: "dropdown",

                  name: "Test",

                  title: "Test",

                  choices: [
                    {
                      value: "item1",

                      text: "CT",
                    },

                    {
                      value: "item2",

                      text: "PET CT",
                    },

                    {
                      value: "item3",

                      text: "MRI",
                    },

                    {
                      value: "item4",

                      text: "USG",
                    },

                    {
                      value: "item5",

                      text: "Doppler",
                    },

                    {
                      value: "item6",

                      text: "MRCP",
                    },

                    {
                      value: "item7",

                      text: "Endoscopy",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "dopplerOptions",

                  visibleIf: "{panel.Test} = 'item5'",

                  startWithNewLine: false,

                  title: "Doppler Options",

                  choices: [
                    {
                      value: "item1",

                      text: "Arterial",
                    },

                    {
                      value: "item2",

                      text: "Venous",
                    },
                  ],
                },

                {
                  type: "text",

                  name: "MRIOptions",

                  visibleIf:
                    "{panel.Test} = 'item3' and {panel.MRIOptions} anyof ['item5']",

                  startWithNewLine: false,

                  title: "MRI Options - Others",

                  hideNumber: true,
                },

                {
                  type: "dropdown",

                  name: "USGOptions",

                  visibleIf: "{panel.Test} = 'item4'",

                  startWithNewLine: false,

                  title: "USG Options",

                  choices: [
                    {
                      value: "item1",

                      text: "(A+P)",
                    },

                    {
                      value: "item2",

                      text: "Thorax",
                    },

                    {
                      value: "item3",

                      text: "Neck",
                    },

                    {
                      value: "item4",

                      text: "BL axillary",
                    },

                    {
                      value: "item5",

                      text: "BL Inguinal",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "CTOptions",

                  visibleIf: "{panel.Test} = 'item1'",

                  startWithNewLine: false,

                  title: "CT Options",

                  choices: [
                    {
                      value: "item1",

                      text: "(A+P)",
                    },

                    {
                      value: "item2",

                      text: "Thorax",
                    },

                    {
                      value: "item3",

                      text: "Neck",
                    },

                    {
                      value: "item4",

                      text: "Oral cavity",
                    },

                    {
                      value: "item5",

                      text: "Brain ",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "PetCTOptions",

                  visibleIf: "{panel.Test} = 'item2'",

                  startWithNewLine: false,

                  title: "PET CT Options",

                  choices: [
                    {
                      value: "item1",

                      text: "FDG",
                    },

                    {
                      value: "item2",

                      text: "DOTA",
                    },

                    {
                      value: "item3",

                      text: "PSMA",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "MRIOptions",

                  visibleIf: "{panel.Test} = 'item3'",

                  startWithNewLine: false,

                  title: "MRI Options",

                  choices: [
                    {
                      value: "item1",

                      text: "Brain",
                    },

                    {
                      value: "item2",

                      text: "Liver",
                    },

                    {
                      value: "item3",

                      text: "Spine",
                    },

                    {
                      value: "item4",

                      text: "Pelvis",
                    },

                    {
                      value: "item5",

                      text: "Others",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "MrcpIhbrDilated",

                  visibleIf: "{panel.Test} = 'item6'",

                  startWithNewLine: false,

                  title: "MRCP (IHBR Dilated)",

                  choices: [
                    {
                      value: "item1",

                      text: "Yes",
                    },

                    {
                      value: "item2",

                      text: "No",
                    },
                  ],
                },

                {
                  type: "dropdown",

                  name: "endoscopy",

                  visibleIf: "{panel.Test} = 'item7'",

                  startWithNewLine: false,

                  title: "Endoscopy",

                  hideNumber: true,

                  choices: [
                    {
                      value: "item1",

                      text: "Bronchoscopy",
                    },

                    {
                      value: "item2",

                      text: "Cystoscopy",
                    },

                    {
                      value: "item3",

                      text: "Laparoscopy",
                    },

                    {
                      value: "item4",

                      text: "Laryngoscopy",
                    },

                    {
                      value: "item5",

                      text: "Mediastinoscopy",
                    },

                    {
                      value: "item6",

                      text: "Thoracoscopy",
                    },

                    {
                      value: "item7",

                      text: "Upper GI endoscopy",
                    },

                    {
                      value: "item8",

                      text: "Arthroscopy",
                    },

                    {
                      value: "item9",

                      text: "Enteroscopy",
                    },

                    {
                      value: "item10",

                      text: "Hysteroscopy",
                    },

                    {
                      value: "item11",

                      text: "Sigmoidoscopy",
                    },

                    {
                      value: "item12",

                      text: "Ureteroscopy",
                    },
                  ],
                },

                {
                  type: "text",

                  name: "dateOfTest",

                  startWithNewLine: false,

                  title: "Date of Test",

                  inputType: "date",
                },

                {
                  type: "text",

                  name: "testFindings",

                  startWithNewLine: false,

                  title: "Test Findings",

                  hideNumber: true,
                },

                {
                  type: "file",

                  name: "uploadFile",

                  startWithNewLine: false,

                  title: "Upload File",
                },
              ],

              panelAddText: "Add Method",

              panelRemoveText: "Remove Method",

              showRangeInProgress: false,
            },

            {
              type: "text",

              name: "Toxicity",

              title: "Toxicity",

              hideNumber: true,
            },

            {
              type: "text",

              name: "ToxicityDetail",

              startWithNewLine: false,

              title: "Toxicity Detail",

              hideNumber: true,
            },

            {
              type: "text",

              name: "GradeCTCAE",

              startWithNewLine: false,

              title: "Grade (CTCAE)",

              hideNumber: true,
            },

            {
              type: "text",

              name: "TreatmentToManageToxicity",

              title: "Treatment to Manage Toxicity",

              hideNumber: true,
            },

            {
              type: "text",

              name: "Remarks",

              startWithNewLine: false,

              title: "Remarks",

              hideNumber: true,
            },
          ],

          panelCount: 1,

          minPanelCount: 1,

          panelAddText: "Add Past Treatment",

          panelRemoveText: "Remove Past Treatment",
        },

        {
          type: "paneldynamic",
          name: "CurrentTreatmentPlan",
          title: "Current Treatment Plan:",
          hideNumber: true,
          templateElements: [
            {
              type: "dropdown",
              name: "TreatmentIntent",
              title: "Treatment Intent:",
              hideNumber: true,
              choices: [
              {
                value: "item1",
                text: "Curative",
              },
              {
                value: "item2",
                text: "Palliative",
              },
              ],
            },
            {
              type: "dropdown",
              name: "LineofTreatment",
              startWithNewLine: false,
              title: "Line of Treatment",
              hideNumber: true,
              choices: [
                {
                  value: "item1",
                  text: "1st",
                },
                {
                  value: "item2",
                  text: "2nd",
                },
                {
                  value: "item3",
                  text: "3rd+",
                },
                {
                  value: "item6",
                  text: "NA",
                },
              ],
            },
            {
              type: "paneldynamic",
              name: "TypeofTreatment",
              title: "Type of Treatment",
              hideNumber: true,
              templateElements: [
                {
                  type: "dropdown",
                  name: "TypeofTreatmentSelected",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Type of Treatment:",
                  hideNumber: true,
                  choices: [
                    "Chemotherapy",
                    "Radiotherapy",
                    "Surgery",
                    "Targeted Therapy",
                    "Hormone Therapy",
                    "Nuclear Medicine",
                    "Others",
                    "Immunotherapy",
                  ],
                },
                {
                  type: "dropdown",
                  name: "Type",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} notempty and {panel.TypeofTreatmentSelected} = 'Radiotherapy'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Type",
                  defaultValue: "item6",
                  choices: [
                    {
                      value: "item1",
                      text: "EBRT",
                    },
                    {
                      value: "item3",
                      text: "3DRT",
                    },
                    {
                      value: "item4",
                      text: "IMRT",
                    },
                    {
                      value: "item5",
                      text: "IGRT",
                    },
                    {
                      value: "item6",
                      text: "NA",
                    },
                    {
                      value: "item7",
                      text: "SBRT",
                    },
                    {
                      value: "item9",
                      text: "Palliative RT",
                    },
                    {
                      value: "item10",
                      text: "Brachytherapy",
                    },
                  ],
                  choicesOrder: "asc",
                },
                {
                  type: "dropdown",
                  name: "Current Treatment",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Immunotherapy'or {panel.TypeofTreatmentSelected} = 'Chemotherapy'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Current Treatment",
                  hideNumber: true,
                  defaultValue: "item6",
                  choices: [
                    {
                      value: "item1",
                      text: "Adjuvant",
                    },
                    {
                      value: "item3",
                      text: "Single Agent",
                    },
                    {
                      value: "item4",
                      text: "Multi Agent (Palliative)",
                    },
                    {
                      value: "item5",
                      text: "NACT",
                    },
                    {
                      value: "item6",
                      text: "NA",
                    },
                  ],
                  choicesOrder: "asc",
                },
                {
                  type: "dropdown",
                  name: "NACTAdjuvant",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Chemotherapy' and {panel.Current Treatment} = 'item1' or {panel.Current Treatment} = 'item5'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "NACT/Adjuvant",
                  hideNumber: true,
                  defaultValue: "item6",
                  choices: [
                    {
                      value: "item1",
                      text: "LV + 5FU",
                    },
                    {
                      value: "item3",
                      text: "FOLFOX",
                    },
                    {
                      value: "item4",
                      text: "Capecitabine",
                    },
                    {
                      value: "item5",
                      text: "CAPOX",
                    },
                    {
                      value: "item6",
                      text: "NA",
                    },
                  ],
                  choicesOrder: "asc",
                  showOtherItem: true,
                },
                {
                  type: "dropdown",
                  name: "MultiAgent(Palliative)",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Chemotherapy' and {panel.Current Treatment} = 'item4'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Multi Agent (Palliative)",
                  hideNumber: true,
                  defaultValue: "item6",
                  choices: [
                    {
                      value: "item1",
                      text: "LV + 5FU",
                    },
                    {
                      value: "item2",
                      text: "IROX",
                    },
                    {
                      value: "item3",
                      text: "FOLFOX",
                    },
                    {
                      value: "item4",
                      text: "Capecitabine",
                    },
                    {
                      value: "item5",
                      text: "CAPOX",
                    },
                    {
                      value: "item6",
                      text: "NA",
                    },
                  ],
                  choicesOrder: "asc",
                  showOtherItem: true,
                },
                {
                  type: "dropdown",
                  name: "SingleAgent",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Chemotherapy' and {panel.Current Treatment} = 'item3'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Single Agent",
                  hideNumber: true,
                  defaultValue: "item1",
                  choices: [
                    {
                      value: "item1",
                      text: "NA",
                    },
                    {
                      value: "item2",
                      text: "Irinotecan",
                    },
                    {
                      value: "item5",
                      text: "Capecitabine",
                    },
                    {
                      value: "item4",
                      text: "Trifluridine + Tipiracil",
                    },
                    {
                      value: "item6",
                      text: "S1 (Tegafur / Gimeracil / Oteracil)",
                    },
                  ],
                  showOtherItem: true,
                },
                {
                  type: "dropdown",
                  name: "TargetedTherapy",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} notempty and {panel.TypeofTreatmentSelected} = 'Targeted Therapy'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Targeted Therapy",
                  hideNumber: true,
                  defaultValue: "item1",
                  choices: [
                    {
                      value: "item1",
                      text: "NA",
                    },
                    {
                      value: "item2",
                      text: "Cetuximab",
                    },
                    {
                      value: "item3",
                      text: "Panitumumab",
                    },
                    {
                      value: "item4",
                      text: "Bevacizumab",
                    },
                    {
                      value: "item5",
                      text: "Ramucirumab",
                    },
                    {
                      value: "item6",
                      text: "Regorafenib",
                    },
                    {
                      value: "item7",
                      text: "Trastuzumab",
                    },
                    {
                      value: "item8",
                      text: "Encorafenib",
                    },
                  ],
                  showOtherItem: true,
                },
                {
                  type: "dropdown",
                  name: "Immunotherapy",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} notempty and {panel.TypeofTreatmentSelected} = 'Immunotherapy'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "Immunotherapy",
                  hideNumber: true,
                  defaultValue: "item1",
                  choices: [
                    {
                      value: "item1",
                      text: "NA",
                    },
                    {
                      value: "item2",
                      text: "Nivolumab",
                    },
                    {
                      value: "item3",
                      text: "Pembrolizumab",
                    },
                    {
                      value: "item4",
                      text: "Nivolumab + Ipilimumab",
                    },
                  ],
                  showOtherItem: true,
                },
                {
                  type: "text",
                  name: "NoofCycles",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Chemotherapy' and {panel.Current Treatment} <> 'item6'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "No of Cycles",
                  inputType: "number",
                  min: 1,
                  max: 100,
                },
                {
                  type: "text",
                  name: "NoofCycles",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Targeted Therapy' and {panel.Targeted Therapy} <> 'item1'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "No of Cycles",
                  inputType: "number",
                  min: 1,
                  max: 100,
                },
                {
                  type: "text",
                  name: "NoofCycles",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Immunotherapy' and {panel.Immunotherapy} <> 'item1'",
                  width: "284px",
                  minWidth: "284px",
                  maxWidth: "284px",
                  startWithNewLine: false,
                  title: "No of Cycles",
                  inputType: "number",
                  min: 1,
                  max: 100,
                },
                {
                  type: "comment",
                  name: "DetailsofTreatment",
                  visibleIf:
                    "{panel.TypeofTreatmentSelected} = 'Surgery' or {panel.TypeofTreatmentSelected} = 'Radiotherapy' or {panel.TypeofTreatmentSelected} = 'Targeted Therapy' or {panel.TypeofTreatmentSelected} = 'Hormone Therapy' or {panel.TypeofTreatmentSelected} = 'Nuclear Medicine' or {panel.TypeofTreatmentSelected} = 'Others'",
                  title: "Details of Treatment",
                  hideNumber: true,
                },
              ],
              panelCount: 1,
              minPanelCount: 1,
              panelAddText: "Add Type of Treatment",
              panelRemoveText: "Remove Type of Treatment",
            },
      ],
      panelCount: 1,
      minPanelCount: 1,
      panelAddText: "Add Treatment Plan",
      panelRemoveText: "Remove Treatment Plan",
    },
    ],
    },
  ],
}
const defaultSurveyJSON2 = {
  logoPosition: "right",
  pages: [
    {
      name: "page2",
      elements: [
        {
          type: "dropdown",
          name: "question4",
          title: "NACT/Adjuvant",
          hideNumber: true,
          defaultValue: "item6",
          isRequired: true,
          choices: [
            {
              value: "item1",
              text: "LV + 5FU",
            },
            {
              value: "item3",
              text: "FOLFOX",
            },
            {
              value: "item4",
              text: "Capecitabine",
            },
            {
              value: "item5",
              text: "CAPOX",
            },
            {
              value: "item6",
              text: "NA",
            },
          ],
          choicesOrder: "asc",
          hasOther: true,
        },
        {
          type: "dropdown",
          name: "MultiAgent(Palliative)",
          title: "Palliative",
          hideNumber: true,
          defaultValue: "item6",
          isRequired: true,
          choices: [
            {
              value: "item1",
              text: "LV + 5FU",
            },
            {
              value: "item2",
              text: "IROX",
            },
            {
              value: "item3",
              text: "FOLFOX",
            },
            {
              value: "item4",
              text: "Capecitabine",
            },
            {
              value: "item5",
              text: "CAPOX",
            },
            {
              value: "item6",
              text: "NA",
            },
          ],
          choicesOrder: "asc",
          hasOther: true,
        },
        {
          type: "dropdown",
          name: "SingleAgent",
          title: "Single Agent",
          hideNumber: true,
          defaultValue: "item1",
          choices: [
            {
              value: "item1",
              text: "NA",
            },
            {
              value: "item2",
              text: "Irinotecan",
            },
            {
              value: "item5",
              text: "Capecitabine",
            },
            {
              value: "item4",
              text: "Trifluridine + Tipiracil",
            },
            {
              value: "item6",
              text: "S1 (Tegafur / Gimeracil / Oteracil)",
            },
          ],
          hasOther: true,
        },
        {
          type: "dropdown",
          name: "Immunotherapy",
          title: "Immunotherapy",
          hideNumber: true,
          defaultValue: "item1",
          choices: [
            {
              value: "item1",
              text: "NA",
            },
            {
              value: "item2",
              text: "Nivolumab",
            },
            {
              value: "item3",
              text: "Pembrolizumab",
            },
            {
              value: "item4",
              text: "Nivolumab + Ipilimumab",
            },
          ],
          hasOther: true,
        },
        {
          type: "dropdown",
          name: "TargetedTherapy",
          title: "Targeted Therapy",
          hideNumber: true,
          defaultValue: "item1",
          choices: [
            {
              value: "item1",
              text: "NA",
            },
            {
              value: "item2",
              text: "Cetuximab",
            },
            {
              value: "item3",
              text: "Panitumumab",
            },
            {
              value: "item4",
              text: "Bevacizumab",
            },
            {
              value: "item5",
              text: "Ramucirumab",
            },
            {
              value: "item6",
              text: "Regorafenib",
            },
            {
              value: "item7",
              text: "Trastuzumab",
            },
            {
              value: "item8",
              text: "Encorafenib",
            },
          ],
          hasOther: true,
        },
      ],
      title: "Treatment",
      description: "Enter Treatment Details",
    },
  ],
}

const defaultSurveyCSS = {
  header: "bg-primary text-white p-3",
  body: "bg-light",
  completedPage: "p-3",
}

const defaultSurveyDATA = {
  Symptoms: ["item1", "item3", "item5"],
  Household: true,
  Notification: true,
  Travel: true,
}

function renderData(a: any): any {
  const temp = a[0]
  console.log("a", a[0])
  const flag =
    temp &&
    temp?.PrimaryTumor &&
    temp?.RegionalLymphNodes &&
    temp?.DistantMetastasis
      ? 1
      : 0

  var survey: any = document.getElementById("surveyElement")
  console.log("survey", survey)

  if (flag) {
    survey.setVariable("render_stage_name", "Stage 1")
    survey.setVariable("hasStage", true)
  } else {
    survey.setVariable("render_stage_name", "Stage 6")
    survey.setVariable("hasStage", true)
  }
}

const defaultSurveyConfig = {
  defaultSurveyCSS,
  defaultSurveyDATA,
  defaultSurveyJSON,
  defaultSurveyJSON2,
  renderData,
}

export default defaultSurveyConfig
